import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'
import { IPublicStatusResponse } from './status.interfaces'

export const statusApi = createApi({
  reducerPath: 'statusApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/status`, (headers) => {
    headers.set('x-request-id', uuidv4())
    return headers
  }),
  endpoints: (builder) => ({
    getPublicStatus: builder.query<IPublicStatusResponse, void>({
      query: () => ({
        url: '',
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetPublicStatusQuery } = statusApi
